import { IQuestion } from '../properties/assessment';
import { useGetChoices } from '../properties/useGetChoices';

const MultipleChoiceQuestion = ({ question, name, value, onChange }: {
    question: IQuestion,
    name: string,
    value?: string,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
    onBlur: () => void;
}) => {
    const { choices } = useGetChoices(question.questionId || '');

    return (
        <div className="form-group">
            <div className="form-check">
                {choices.map((choice, index) => (
                    <div key={index} className='my-2'>
                        <input
                            type="radio"
                            className="form-check-input"
                            id={`${question.questionId}-${index}`}
                            name={name}
                            value={choice.choiceid}
                            checked={value === choice.choiceid}
                            onChange={onChange}
                        />
                        <label className="form-check-label" htmlFor={`${question.questionId}-${index}`}>{choice.name}</label>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MultipleChoiceQuestion;
